<template>
<div class="tileView">
  <PageTopForm>
    <div slot="form">
      <el-form-item label="模型名称：">
        <el-input v-model="formInline.searchText" placeholder="请输入" :maxlength="20" show-word-limit clearable @keyup.enter.native="onSubmit"></el-input>
      </el-form-item>
      <el-form-item label="模型类型：">
        <el-select v-model="formInline.type" placeholder="请选择" clearable @keyup.enter.native.stop="onSubmit">
          <el-option v-for="item in tileTypeOptions" :label="item.name" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
      <div class="search-btn">
        <!-- <span @click="onSubmit">查询</span>
        <span @click="reset">重置</span> -->
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="default" @click="reset">重置</el-button>
      </div>
    </div>
  </PageTopForm>
  <div class="topButtons">
    <el-button type="primary" icon="el-icon-document-add" @click="openAddTile" :disabled="permissionLevel <= PermissionLevel.LOOKER">新建</el-button>
    <el-button type="danger" icon="el-icon-delete" @click="removeSelected" :disabled="selectedTiles.length<=0 || permissionLevel <= PermissionLevel.LOOKER">删除</el-button>
  </div>
  <el-table
      ref="multipleTable"
      stripe
      :data="tableData"
      max-height="720"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange">
    <el-table-column
      type="selection"
      class="selection"
      :width="55*zoomFactor">
    </el-table-column>
    <el-table-column label="序号" :width="50*zoomFactor">
      <template slot-scope="scope">
        <span class="num">{{scope.$index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-for="(item ,index) in columns"
      :key="index"
      :prop="item.prop"
      :label="item.label"
      :width="item.width"
      :formatter="item.formatter"
      show-overflow-tooltip
      :align="item.num?'right':'left'"
      header-align="left"
      >
    </el-table-column>
    <el-table-column label="操作" :width="90*zoomFactor">
      <template slot-scope="scope">
<!--        <div class="action-btn">-->
<!--          <span @click="preview(scope.row)">预览</span>-->
<!--          <span class="line"></span>-->
<!--          &lt;!&ndash; <span @click="editModel(scope.row)">编辑</span>-->
<!--          <span class="line"></span> &ndash;&gt;-->
<!--          &lt;!&ndash; <el-popconfirm-->
<!--            confirm-button-text='确定'-->
<!--            cancel-button-text='取消'-->
<!--            confirm-button-type="warning"-->
<!--            icon="el-icon-info"-->
<!--            icon-color="red"-->
<!--            :title="scope.row.hasBindArea?'该模型已绑定区域，你确认要删除吗？':'你确定删除该数据吗？'"-->
<!--            @confirm="removeSingleTile(scope.row)"-->
<!--          >-->
<!--            <span slot="reference">删除</span>-->
<!--          </el-popconfirm> &ndash;&gt;-->
<!--          <span @click="removeSingleTile(scope.row)">删除</span>-->
<!--        </div>-->
        <div class="action-btn">
          <!-- <el-tooltip content="预览" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-browse" @click="preview(scope.row)"></Icon>
          </el-tooltip> -->
          <el-tooltip content="编辑" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-edit" @click="editModel(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </el-tooltip>
          <el-tooltip content="删除" placement="top" effect="light" :open-delay="1000" :enterable="false">
            <Icon name="icon-ashbin" @click="removeSingleTile(scope.row)" :disabled="permissionLevel <= PermissionLevel.LOOKER"></Icon>
          </el-tooltip>
        </div>
      </template>
    </el-table-column>
    <template slot="empty">
      <Empty></Empty>
    </template>
  </el-table>
  <div class="bottom">
    <div class="page-wrapper">
      <div class="bottom-left">
        <span class="title">已选择</span><span class="value">{{selectedTiles.length}}</span><span  class="title">项，共</span><span class="value">{{total}}</span><span class="title">条</span>
      </div>
      <div class="bottom-right">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

    </div>
  </div>
  <CesiumPreview ref="preview"></CesiumPreview>
  <TileAttribute ref="tileAttribute" @refresh="refreshTable"></TileAttribute>
</div>
</template>

<script>
import PageTopForm from '@/components/PageTopForm/PageTopForm'
import CesiumPreview from './Components/CesiumPreview.vue'
import TileAttribute from './Components/TileAttribute.vue'
import { getModelPage, delModel } from '@/api/model'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'Tile',
  props: {},
  components: { PageTopForm, CesiumPreview, TileAttribute },
  data () {
    return {
      // 瓦片类型
      tileTypeOptions: [
        { value: 'TWO_DIMENSIONS', name: '二维地图' },
        { value: 'THREE_DIMENSIONS', name: '三维地图' }
      ],
      // 精度类型
      levelOptions: [
        { value: 'ONE_TO_150', name: '1:150' },
        { value: 'ONE_TO_300', name: '1:300' },
        { value: 'ONE_TO_500', name: '1:500' },
        { value: 'ONE_TO_1000', name: '1:1000' },
        { value: 'ONE_TO_2000', name: '1:2000' }
      ],
      formInline: {
        searchText: undefined,
        type: undefined
      },
      columns: [
        {
          prop: 'name',
          label: '模型名称'
          // width: '200'
        },
        {
          prop: 'type',
          label: '模型类型',
          // width: '200',
          formatter: (row, column) => {
            return this.tileTypeName(row.type)
          }
        },
        {
          prop: 'dataPrecision',
          label: '数据精度',
          // width: '200',
          formatter: (row, column) => {
            return this.tileLevelName(row.dataPrecision)
          }
        },
        {
          prop: 'createTime',
          label: '上传时间',
          custom: true,
          formatter: (row, column) => {
            return new Date(row.createTime).format('yyyy/MM/dd hh:mm:ss')
          }
        }
      ],
      tableData: [],
      // 选中的数据
      selectedTiles: [],
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 每页显示条数
      pageSize: 15,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['permissionLevel'])
  },
  mounted () {
    this.refreshTable()
  },
  methods: {
    onSubmit () {
      this.loadTileData()
    },
    reset () {
      this.formInline = this.$options.data().formInline
      this.loadTileData()
    },
    tileLevelName (value) {
      for (let i = 0; i < this.levelOptions.length; i++) {
        if (this.levelOptions[i].value === value) {
          return this.levelOptions[i].name
        }
      }
      return ''
    },
    tileTypeName (value) {
      for (let i = 0; i < this.tileTypeOptions.length; i++) {
        if (this.tileTypeOptions[i].value === value) {
          return this.tileTypeOptions[i].name
        }
      }
      return ''
    },
    // 选择列表
    handleSelectionChange (val) {
      this.selectedTiles = val
    },
    // 加载数据
    loadTileData () {
      getModelPage({
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        type: this.formInline.type,
        name: this.formInline.searchText
      }).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
        if (this.tableData.length <= 0 && this.currentPage > 1) {
          this.currentPage = 1
          this.loadTileData()
        }
      })
    },
    onSizeChange (size) {
      this.pageSize = size
      this.loadTileData()
    },
    onCurrentChange (page) {
      this.currentPage = page
      this.loadTileData()
    },
    // 移除模型
    removeTile (ids) {
      delModel({
        ids: ids
      }).then(res => {
        if (res.code === 200) {
          this.$Message('success', '删除成功!')
          this.refreshTable()
        }
      })
    },
    // 添加
    openAddTile () {
      this.$refs.tileAttribute.open()
    },
    // 预览
    preview (item) {
      this.$refs.preview.open(item)
    },
    editModel (item) {
      this.$refs.tileAttribute.open(item.id)
    },
    // 删除
    removeSingleTile (item) {
      // this.removeTile([item.id])
      this.$Delete({
        message: item.hasBindArea ? '该模型已绑定区域，你确认要删除吗？' : '你确定删除该数据吗？',
        confirm: () => {
          this.removeTile([item.id])
        },
        cancel: () => {
        }
      })
    },
    // 批量删除
    removeSelected () {
      this.$Delete({
        confirm: () => {
          const ids = []
          for (let i = 0; i < this.selectedTiles.length; i++) {
            ids.push(this.selectedTiles[i].id)
          }
          this.removeTile(ids)
        },
        cancel: () => {
        }
      })
    },
    // 刷新数据
    refreshTable () {
      this.loadTileData()
    }
  }

}
</script>

<style>
  .el-pagination {
    margin-top: 0;
  }
</style>
<style lang="scss" scoped>
.tileView{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  color: #ffffff;
  padding: 20px 32px 0px 32px;
  .search-btn{
    margin-left: -10px;
  }
  .buttons{
    text-align: left;
    margin-bottom: 20px;
    // padding: 0px 30px;
  }
  .bottom {
    position: absolute;
    height: 54px;
    width: 100%;
    bottom: 0px;
    left: 0px;
    padding: 0 32px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 14px;
    .page-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .bottom-left {
        /*line-height: 1;*/
        .title{
          color: $font-color9;
        }
        .value{
          margin: 0px 10px;
          color: $font-colorf;
        }
      }
    }

  }
}

</style>
